import React from 'react';
import { motion } from 'framer-motion';
import { Eye, Users, Zap } from 'lucide-react';
export function ThreeDoors() {
  const doors = [{
    id: 1,
    name: 'CLARIDAD',
    time: '3 minutos',
    icon: Eye,
    problem: "Cuando tu mente dice: 'no sé por dónde…'",
    solution: 'No haces un plan. Defines el primer movimiento.',
    insight: 'La claridad real no es entender todo. Es saber cuál es el siguiente clic.'
  }, {
    id: 2,
    name: 'SOLEDAD',
    time: '2–4 minutos',
    icon: Users,
    problem: "Cuando aparece el miedo silencioso: 'estoy solo con esto'.",
    solution: 'No lo tapas. Lo nombras y usas un guion que baja la amenaza sin mendigar rescate.',
    insight: null
  }, {
    id: 3,
    name: 'CONFIANZA',
    time: '5–10 minutos',
    icon: Zap,
    problem: "Cuando la duda te grita: 'no puedes'.",
    solution: 'No discutes. Creas micro-evidencia.',
    insight: "Una prueba pequeña que le enseña al cerebro: 'Sí puedo empezar, incluso con miedo.'"
  }];
  return <section className="py-28 px-4 bg-dark-900 relative overflow-hidden" data-id="element-143">
      {/* Background glow spot */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-amber-900/10 blur-[100px] rounded-full pointer-events-none" data-id="element-144" />

      <div className="max-w-7xl mx-auto relative z-10" data-id="element-145">
        <div className="text-center mb-20" data-id="element-146">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-black text-white mb-6 uppercase tracking-tight" data-id="element-147">
            Presento: EL MIEDO DIARIO <br data-id="element-148" />
            <span className="text-amber-500 text-glow-amber" data-id="element-149">
              Sistema 3 Puertas
            </span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl text-gray-400 max-w-3xl mx-auto" data-id="element-150">
            No es motivación. No es terapia. Es un protocolo de ejecución para
            el momento exacto en el que te bloqueas.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-151">
          {doors.map((door, index) => <motion.div key={door.id} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} whileHover={{
          y: -10,
          boxShadow: '0 20px 40px -10px rgba(212, 168, 83, 0.15)'
        }} className="bg-dark-800 rounded-xl p-8 border-t-4 border-amber-600/30 hover:border-amber-500 transition-all duration-300 group relative" data-id="element-152">
              <div className="absolute top-0 right-0 p-4 opacity-10 group-hover:opacity-20 transition-opacity" data-id="element-153">
                <door.icon size={120} data-id="element-154" />
              </div>

              <div className="relative z-10" data-id="element-155">
                <div className="flex items-center gap-3 mb-6" data-id="element-156">
                  <div className="w-12 h-12 rounded-full bg-amber-500/10 flex items-center justify-center text-amber-500 group-hover:bg-amber-500 group-hover:text-dark-900 transition-colors" data-id="element-157">
                    <door.icon size={24} data-id="element-158" />
                  </div>
                  <div data-id="element-159">
                    <h3 className="text-amber-gold font-bold tracking-wider text-sm" data-id="element-160">
                      PUERTA {door.id}
                    </h3>
                    <h4 className="text-2xl font-bold text-white" data-id="element-161">
                      {door.name}
                    </h4>
                  </div>
                </div>

                <div className="inline-block px-3 py-1 bg-dark-900 rounded text-xs font-mono text-gray-400 mb-6 border border-white/5" data-id="element-162">
                  {door.time}
                </div>

                <div className="space-y-4" data-id="element-163">
                  <p className="text-gray-300 font-medium border-l-2 border-amber-900/50 pl-3" data-id="element-164">
                    {door.problem}
                  </p>
                  <p className="text-white" data-id="element-165">{door.solution}</p>
                  {door.insight && <p className="text-amber-gold/80 text-sm italic mt-4" data-id="element-166">
                      {door.insight}
                    </p>}
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}